<template>
    <p-inc-todo-card
        :item = "item"
    >
        <template v-slot:comment>
            <div class="v-flex">
                <div class="card-subtitle status-line">
                    {{ item.completeStatus }}
                </div>
                <v-spacer/>
                <div class="card-subtitle" :class="textColor()" v-if="item.begin && !future">
                    {{ delay }} Tage
                </div>
            </div>
        </template>
    </p-inc-todo-card>
 </template>

<script>

import Core             from "@/modules/core/service/Core";
import PIncTodoCard     from "@/modules/inc/todos/components/private/PIncTodoCard.vue";
import IncTodoCardMixin from "@/modules/inc/todos/components/mixins/IncTodoCardMixin";

export default {
    name: "PIncOpenIncidentCard",

    components: {
        PIncTodoCard
    },

    mixins: [
        IncTodoCardMixin
    ],

    computed: {
        delay () {
            return Core.format.delayInDays(this.item.begin);
        },

        future () {
            return Core.format.future(this.item.begin)
        }
    },

    methods: {
        textColor () {
            const delay = Core.format.delayInMonth(this.item.begin);
            if (delay >= 3 || !this.item.begin) {
                return "error--text"
            }

            return 'black--text';
        }
    }
}
</script>

<style scoped>

.card-subtitle {
    font-size: 13px;
}

.status-line {
    max-width: calc(100% - 65px);
}

.status-line {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

</style>